var _defs, _g, _g2, _path, _g3, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFhoSearchOption = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "group_profile_default",
    "data-name": "group profile default",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.429,
    height: 17.099,
    viewBox: "0 0 24.429 17.099",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2851",
    "data-name": "Rectangle 2851",
    width: 6.107,
    height: 6.107,
    fill: "#1976d2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2852",
    "data-name": "Rectangle 2852",
    width: 8.549,
    height: 8.549,
    fill: "#1976d2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4263",
    "data-name": "Group 4263",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4262",
    "data-name": "Group 4262"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4261",
    "data-name": "Group 4261"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4260",
    "data-name": "Group 4260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4252",
    "data-name": "Group 4252",
    transform: "translate(17.71 1.221)",
    opacity: 0.4,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4251",
    "data-name": "Group 4251"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4250",
    "data-name": "Group 4250",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4472",
    "data-name": "Path 4472",
    d: "M17.554,7.107A3.053,3.053,0,1,0,14.5,4.053a3.053,3.053,0,0,0,3.053,3.053",
    transform: "translate(-14.501 -1)",
    fill: "#1976d2"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4255",
    "data-name": "Group 4255",
    transform: "translate(7.939)",
    opacity: 0.4,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4254",
    "data-name": "Group 4254"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4253",
    "data-name": "Group 4253",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4473",
    "data-name": "Path 4473",
    d: "M10.776,8.549A4.275,4.275,0,1,0,6.5,4.275a4.275,4.275,0,0,0,4.275,4.275",
    transform: "translate(-6.501)",
    fill: "#1976d2"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4474",
    "data-name": "Path 4474",
    d: "M18.187,7H16.66a2.766,2.766,0,0,0-1.568.489,5.13,5.13,0,0,1,.97.855,1.531,1.531,0,0,1,.6-.122h1.527a1.764,1.764,0,0,1,1.678,1.832.611.611,0,0,0,1.221,0A2.984,2.984,0,0,0,18.187,7",
    transform: "translate(3.34 1.549)",
    fill: "#0d47a1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4258",
    "data-name": "Group 4258",
    transform: "translate(0.611 1.221)",
    opacity: 0.4,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4257",
    "data-name": "Group 4257"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4256",
    "data-name": "Group 4256",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4475",
    "data-name": "Path 4475",
    d: "M3.554,7.107A3.053,3.053,0,1,0,.5,4.053,3.053,3.053,0,0,0,3.554,7.107",
    transform: "translate(-0.501 -1)",
    fill: "#1976d2"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4476",
    "data-name": "Path 4476",
    d: "M14.382,7.625c-1.275,0-1.588.458-3.053.458s-1.782-.458-3.053-.458a4.208,4.208,0,0,0-3.522,1.79A4.372,4.372,0,0,0,4,11.869v1.71a1.833,1.833,0,0,0,1.832,1.832H16.825a1.833,1.833,0,0,0,1.832-1.832v-1.71a4.369,4.369,0,0,0-.749-2.454,4.207,4.207,0,0,0-3.526-1.79",
    transform: "translate(0.885 1.688)",
    fill: "#0d47a1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4477",
    "data-name": "Path 4477",
    d: "M6,7.489A2.776,2.776,0,0,0,4.429,7H2.9A2.984,2.984,0,0,0,0,10.053a.611.611,0,0,0,1.221,0A1.763,1.763,0,0,1,2.9,8.221H4.429a1.531,1.531,0,0,1,.6.122A5.3,5.3,0,0,1,6,7.489Z",
    transform: "translate(0 1.549)",
    fill: "#0d47a1"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFhoSearchOption);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fho-search-option.82631b2ec8055a9c9b1e3dfab67e467d.svg";